import { createContext, useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import Iconify from 'src/components/Iconify';

export const SidebarContext = createContext({ isExpanded: false });

// Grupo colapsavel de itens, com label — usado por toda sidebar que precisa
// organizar mais de ~4 itens em secoes (SidebarDashboard, MarketingSidebar).
export const SidebarGroup = ({ children, label }) => {
    const { isExpanded } = useContext(SidebarContext);
    const [isOpen, setIsOpen] = useState(true);

    const toggle = () => setIsOpen(!isOpen);

    return (
        <div className="mb-4 last:mb-0">
            {isExpanded && label && (
                <div
                    onClick={toggle}
                    className="flex items-center justify-between px-3 mb-2 animate-in fade-in duration-200 group cursor-pointer hover:bg-gray-50/50 rounded-md py-1 select-none"
                >
                    <span className="text-sm font-semibold text-gray-900">
                        {label}
                    </span>
                    <Iconify
                        icon="solar:alt-arrow-down-linear"
                        width={16}
                        height={16}
                        className={`text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                    />
                </div>
            )}
            <div className={`space-y-0.5 overflow-hidden transition-all duration-300 ease-in-out ${!isExpanded || isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
                {children}
            </div>
        </div>
    );
};

export const SidebarMenuButton = ({ title, onClick, path, icon, tag }) => {
    const { isExpanded } = useContext(SidebarContext);
    const location = useLocation();

    // Check strict or nested path
    const active = location.pathname === path || location.pathname.startsWith(path + '/');

    const ButtonContent = (
        <button
            onClick={onClick}
            className={`
                group relative flex w-full items-center gap-3 rounded-xl px-3 py-1.5 text-[13px]
                transition-all duration-200 ease-in-out border border-transparent
                ${!isExpanded ? 'justify-center px-0' : ''}
                ${active
                    ? 'bg-[#7C3AED]/10 text-[#7C3AED]'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }
            `}
        >
            {icon && (
                <Iconify
                    icon={icon}
                    width={16}
                    height={16}
                    className={`
                        transition-colors duration-200 flex-shrink-0
                        ${active ? 'text-[#7C3AED]' : 'text-gray-400 group-hover:text-gray-700'}
                    `}
                />
            )}

            {isExpanded && (
                <>
                    <span className="truncate flex-1 text-left animate-in fade-in duration-200">
                        {title}
                    </span>
                    {tag && (
                        <span className="flex-shrink-0 px-1.5 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wide bg-violet-100 text-violet-700">
                            {tag}
                        </span>
                    )}
                    {active && (
                        <div className="w-1.5 h-1.5 rounded-full bg-[#7C3AED]" />
                    )}
                </>
            )}
        </button>
    );

    if (!isExpanded) {
        return (
            <Tooltip title={title} placement="right" arrow>
                {ButtonContent}
            </Tooltip>
        );
    }

    return ButtonContent;
};
